import ASTBlock from "../ASTBlock";
import Blockly from 'blockly';

export default class logic_operators extends ASTBlock {
    constructor(color) {
        super(color, "logic_operators")
        this.predefinedInputs = {}
        this.TOP_LEVEL = undefined
    }

    addToBlockly() {
        var json = {
            "tooltip": "",
            "helpUrl": "",
            "message0": "%1 %2 %3",
            "args0": [{
                    "type": "input_value",
                    "name": "arg0"
                },
                {
                    "type": "field_dropdown",
                    "name": "operator",
                    "options": [
                        [
                            ">",
                            ">"
                        ],
                        [
                            "<",
                            "<"
                        ],
                        [
                            "=",
                            "=="
                        ],
                        [
                            ">=",
                            ">="
                        ],
                        [
                            "<=",
                            "<="
                        ]
                    ]
                },
                {
                    "type": "input_value",
                    "name": "arg1"
                }
            ],
            "output": "Boolean",
            "inputsInline": true
        }

        let that = this
        Blockly.Blocks[this.name] = {
            init: function() {
                this.jsonInit(json);
                this.setColour(that.color)
            }

        }
    }
}